module.exports = __webpack_public_path__ + "img/let-that-shit-go_B09NR5R6Y8.ef2b3c95.jpg";